/* unplugin-vue-components disabled */import script from "./TodoDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TodoDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./TodoDetailModal.vue?vue&type=style&index=0&id=f9a646c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9a646c2"]])

export default __exports__